/**
 * FAQ page for the Wellness AI web app
 * Contains frequently asked questions and answers
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/FAQ.css';

const FAQ = () => {
  const navigate = useNavigate();
  const [openQuestion, setOpenQuestion] = useState(null);

  const handleBackToSettings = () => {
    navigate('/settings');
  };

  const toggleQuestion = (index) => {
    setOpenQuestion(openQuestion === index ? null : index);
  };

  const faqData = [
    {
      question: "How does the AI Wellness Rep work?",
      answer: "Our AI Wellness Rep uses advanced natural language processing to provide supportive conversations. It's trained on therapeutic principles and provides a safe space to express your thoughts and feelings. However, it's not a replacement for professional human therapy for serious mental health conditions."
    },
    {
      question: "Is my conversation data private and secure?",
      answer: "Yes, your privacy is our top priority. All conversations are encrypted and stored securely. We never share your personal information or conversation data with third parties. Your data is used only to improve your experience with our AI Wellness Rep."
    },
    {
      question: "How many tokens do I get with my subscription?",
      answer: "Token allocation depends on your subscription plan. Basic plans typically include 100 tokens per month, while premium plans offer unlimited conversations. Each message you send uses one token."
    },
    {
      question: "Can I change the wellness rep's gender?",
      answer: "Yes! You can switch between male and female wellness rep avatars at any time during your conversation using the gender selector in the top right corner of the conversation interface."
    },
    {
      question: "What if I'm experiencing a mental health crisis?",
      answer: "If you're experiencing a mental health emergency, please contact emergency services immediately (911 in the US) or reach out to a crisis helpline like the National Suicide Prevention Lifeline (988). Our AI Wellness Rep is designed for supportive conversations, not crisis intervention."
    },
    {
      question: "Can I access my conversation history?",
      answer: "Your recent conversations are automatically saved and accessible during your session. For longer-term history access, this feature may be available in future updates to your subscription plan."
    },
    {
      question: "How do I cancel my subscription?",
      answer: "You can manage your subscription through your account settings. If you need to cancel, you can deactivate your account from the Settings page, which will cancel any active subscriptions."
    },
    {
      question: "Is the AI Wellness Rep available 24/7?",
      answer: "Yes! One of the benefits of our AI Wellness Rep is that it's available whenever you need support, 24 hours a day, 7 days a week. No appointment necessary."
    }
  ];

  return (
    <div className="faq-page">
      <div className="faq-container">
        <div className="faq-header">
          <button 
            onClick={handleBackToSettings}
            className="back-button"
            aria-label="Back to settings"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
            </svg>
            Back to Settings
          </button>
          <h1>Frequently Asked Questions</h1>
        </div>

        <div className="faq-content">
          {faqData.map((item, index) => (
            <div key={index} className="faq-item">
              <button 
                className={`faq-question ${openQuestion === index ? 'active' : ''}`}
                onClick={() => toggleQuestion(index)}
              >
                <span>{item.question}</span>
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="16" 
                  height="16" 
                  fill="currentColor" 
                  viewBox="0 0 16 16"
                  className={`chevron ${openQuestion === index ? 'rotated' : ''}`}
                >
                  <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                </svg>
              </button>
              {openQuestion === index && (
                <div className="faq-answer">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="faq-footer">
          <p>Still have questions? Our AI Wellness Rep is here to help with any concerns you might have.</p>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
